import { storyblokEditable } from '@storyblok/react/rsc'
import { clsx } from 'clsx'
import { type FC } from 'react'

import { Link } from 'base-ui'

import { getStoryblokHrefLink } from '../../getStoryblokHrefLink'
import { type StoryblokComponentProps } from '../../model'
import { type StoryblokColumnCardType } from '../../model/storyblokTypes.generated'
import { StoryblokComponentsRenderer } from '../StoryblokComponentsRenderer'

export const StoryblokColumnCard: FC<
  StoryblokComponentProps<StoryblokColumnCardType>
> = ({ blok }) => {
  if (blok.contentLink) {
    return (
      <Link
        href={getStoryblokHrefLink(blok.contentLink)}
        {...storyblokEditable(blok)}
        className={clsx(
          'flex flex-col items-center rounded-2xl bg-light-primary-low p-6 text-dark-primary-max no-underline',
          blok.backgroundColor === 'now' && 'bg-light-brand-low',
          blok.backgroundColor === 'white' && 'bg-light-primary-low',
          blok.backgroundColor === 'light' && 'bg-light-primary-medium',
        )}
      >
        <StoryblokComponentsRenderer bloks={blok.content} />
      </Link>
    )
  }

  return (
    <div
      {...storyblokEditable(blok)}
      className={clsx(
        'flex size-full flex-col items-center rounded-2xl bg-light-primary-low p-6',
        blok.backgroundColor === 'now' && 'bg-light-brand-low',
        blok.backgroundColor === 'white' && 'bg-light-primary-low',
        blok.backgroundColor === 'light' && 'bg-light-primary-medium',
      )}
    >
      <StoryblokComponentsRenderer bloks={blok.content} />
    </div>
  )
}
